module.exports = __webpack_public_path__ + "static/media/file.1b5ec70a.svg";